module.exports = __webpack_public_path__ + "static/girl2-347308679d08c4bc3b4fb0311ebee728.png";